import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query Courses(
    $filter: FilterCourseInput
    $page: Int
    $perPage: Int
    $search: String
    $status: StatusEnum
  ) {
    Courses(filter: $filter, page: $page, perPage: $perPage, search: $search, status: $status) {
      items {
        id
        name
        active
        status
        slug
        releaseDate
        modality {
          name
        }
        courseGroup {
          name
          category {
            name
          }
        }
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  id: number;
  name: string;
  active: boolean;
  status: string;
  slug: string;
  releaseDate?: string;
  modality: {
    name: string;
  };
  courseGroup: {
    name: string;
    category: {
      name: string;
    };
  };
}

export interface GetAllGql {
  Courses: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
